export default __webpack_public_path__ + "static/media/hht2_ep03_timeline_q01_b.9b619708.png";